import { Badge, Box, Text, Tooltip } from '@optiaxiom/react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@optiaxiom/react/unstable';
import { IconScrewdriverWrench } from '@optimizely/axiom-icons';

import { CustomIcon } from '@frontend/components/ui';
import { Tool } from '@frontend/types';

import type { ToolsTableRow } from '../types';

const NameCell = ({ toolRow }: { toolRow: ToolsTableRow }) => {
  const rowData = toolRow;
  if (rowData.isRegistry) {
    return (
      <Box display="flex" alignItems="center" gap="8">
        <Text>{rowData.name}</Text>
        {!rowData.registry.organization_id && (
          <Tooltip content="Opal System tools">
            <Box>
              <CustomIcon name="optimizely" alt="Opal System Tools" height={12} />
            </Box>
          </Tooltip>
        )}
        <Badge variant="strong">{rowData.items.length}</Badge>
      </Box>
    );
  }

  return <ToolName tool={rowData.tool} />;
};

const ToolName = ({ tool }: { tool: Tool }) => {
  return (
    <Box>
      <Box display="flex" alignItems="center" gap="8">
        {tool.name}
        {tool.is_system_function && (
          <Tooltip content="System tool">
            <Box>
              <CustomIcon name="optimizely" alt="Opal System Tool" height={12} />
            </Box>
          </Tooltip>
        )}
        {tool.is_preview && <Badge intent="information">Preview</Badge>}
      </Box>
      <HoverCard>
        <HoverCardTrigger asChild>
          <Text fontSize="sm" color="fg.tertiary" lineClamp="1" cursor="pointer">
            {tool.description}
          </Text>
        </HoverCardTrigger>
        <HoverCardContent>
          <Box display="flex" flexDirection="column" gap="8" style={{ maxHeight: '320px' }}>
            <Box display="flex" gap="8" alignItems="center">
              <IconScrewdriverWrench size={16} />
              <Text fontWeight="400">{tool.service.name}</Text>
              {!tool.service.organization_id && (
                <CustomIcon name="optimizely" alt="Opal System Tool" height={12} />
              )}
            </Box>
            <Text fontWeight="500">{tool.name}</Text>
            <Box overflowY="auto">
              <Text fontSize="sm" color="fg.tertiary">
                {tool.description}
              </Text>
            </Box>
          </Box>
        </HoverCardContent>
      </HoverCard>
    </Box>
  );
};

export default NameCell;
